import { consumirServicioEncirptacion } from 'api';
import { SimpleMaskInputField, SimplePasswordInputField } from 'components/InputsMex/SimpleInputs';
import SimpleContainer from 'components/InputsMex/containers/SimpleContainer';
import SimpleErrorMessage from 'components/InputsMex/containers/SimpleErrorMessage';
import { ControllerRender, TextInput, TextInputMask } from 'components/InputsMex/inputs';
import SeleccionarTarjeta from 'components/Polizas/FormPago/SeleccionarTarjeta';
import { ambienteAplicacion, urlPago } from 'constants/urls';
import { useAccionesPantallaPago, usePantallaPago } from 'contexts/FormPagoContext';
import useCustomToast from 'hooks/useCustomToasts';
import useQueryParams from 'hooks/useQueryParams';
import React, { useCallback, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { CVV_RULES, EXPIRACION_RULES, MEDIOS_PAGO } from '../constants';

const FormTarjeta = () => {
  const methods = useFormContext();

  const { idPoliza } = useQueryParams();

  const tarjetaSeleccionada = methods.watch('tarjetaSeleccionada');

  const { addWarningToast } = useCustomToast();

  const [leyendaTarjeta, setLeyendaTarjeta] = useState(null);

  const [longitudCvv, setLongitudCvv] = useState(null);

  const medioPago = methods.watch('medioPago');

  const numTarjeta = methods.watch('numTarjeta');

  const statePantalla = usePantallaPago();
  const actionsPantalla = useAccionesPantallaPago();

  const onChangeTipoTarjeta = useCallback(
    (onChange) => (value) => {
      onChange(value);
      methods.setValue('numTarjeta', null, {
        shouldDirty: false,
        shouldValidate: false,
      });
    },
    []
  );

  const onClickValidar = useCallback(async () => {
    actionsPantalla.setValidandoTarjeta(true);
    actionsPantalla.setTarjetaValida(false);

    const numTarjetaForm = methods.getValues('numTarjeta');
    const valid = await methods.trigger('numTarjeta');
    if (valid) {
      const Data = {
        datosPago: {
          ambiente: ambienteAplicacion,
          cotPasoCodigo: 'validarTarjeta',
          polCodigo: idPoliza,
          numTarjeta: numTarjetaForm,
          isFromLinkCobro: statePantalla.isFromLinkCobro,
        },
      };

      try {
        const res = await consumirServicioEncirptacion(urlPago, Data);
        console.log('RES VALIDAR: ', res);

        if (res?.transaccion === false && res?.errorType === 'validacion-continuar-pago') {
          addWarningToast(res?.message);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
          return;
        }

        if (
          res?.transaccion === true &&
          res?.pago?.datosTarjeta &&
          res.pago.datosTarjeta.bancoNombre &&
          res.pago.datosTarjeta.longitudCvv
        ) {
          setLongitudCvv(res?.pago?.longitudCvv);
          setLeyendaTarjeta(`${res.pago.datosTarjeta.bancoNombre} - ${res.pago.datosTarjeta.tipoTarjeta}`);
          actionsPantalla.setTarjetaValida(true);
        } else if (res?.transaccion === false) {
          let errorMessage = [<h3 key="-1">Ha ocurrido un problema al momento de procesar tu información</h3>];

          if (res?.pago?.msgError) {
            if (Array.isArray(res.pago.msgError)) {
              res.pago.msgError.forEach((msg, index) => errorMessage.push(<p key={index}>{msg}</p>));
            }
          }

          if (res?.pago?.msgError || res?.msgError) {
            errorMessage.push(<p key="-2">{res?.pago?.msgError || res?.msgError}</p>);
          }

          if (res?.pago?.error_Message || res?.error_Message) {
            errorMessage.push(<p key="-3">{res?.pago?.error_Message || res?.error_Message}</p>);
          }
          console.log(errorMessage);
          addWarningToast(<>{errorMessage}</>, { autoDismiss: false });
        }
      } catch (error) {
        console.log(error);
      }
    }
    actionsPantalla.setValidandoTarjeta(false);
  }, []);

  useEffect(() => {
    actionsPantalla.setTarjetaValida(false);
  }, [numTarjeta]);

  return (
    <React.Fragment>
      <div className="col-12 p-0 mt-3">
        <h3 className="font-mex mt-2 ml-2 ml-sm-0">Información de tarjeta</h3>
      </div>
      <ControllerRender
        name="tarjetaSeleccionada"
        defaultValue={null}
        rules={{
          required: 'Este campo es obligatorio',
        }}
        render={({ value, onChange }) => (
          <React.Fragment>
            <SeleccionarTarjeta
              setTarjetaSeleccionada={onChangeTipoTarjeta(onChange)}
              tarjetaSeleccionada={value?.typeName}
              disabled={statePantalla.loadingForm}
            />
            <div className="col-12">
              <SimpleErrorMessage name="tarjetaSeleccionada" />
            </div>
          </React.Fragment>
        )}
      />

      {tarjetaSeleccionada && (
        <React.Fragment>
          <div className="col-12">
            <div className="d-flex flex-row justify-content-around">
              <SimpleMaskInputField
                name="numTarjeta"
                label="Número de tarjeta"
                unmask
                disabled={statePantalla.loadingForm}
                rules={{
                  required: 'Este campos es obligatorio',
                  validate: {
                    length: (value) => {
                      if (value?.length !== tarjetaSeleccionada.length) {
                        return 'Por favor ingrese todos los números de la tarjeta';
                      }
                      return true;
                    },
                  },
                }}
                {...tarjetaSeleccionada}
              />

              <div className="align-self-center ml-3">
                <div style={{ height: '1.8rem' }} />
                <button
                  onClick={onClickValidar}
                  type="button"
                  className="btn btn-primary btn-block px-4 py-2"
                  disabled={statePantalla.loadingForm || statePantalla.isTarjetaValida}
                >
                  {statePantalla?.isValidandoTarjeta ? 'Validando...' : 'Validar'}
                </button>
              </div>
            </div>
          </div>
          {statePantalla.isTarjetaValida && (
            <React.Fragment>
              <div className="col-12">{leyendaTarjeta && <h6>{leyendaTarjeta}</h6>}</div>

              <div className="col-12">
                <SimpleContainer label="Nombre del titular" name="titular">
                  <TextInput
                    inputProps={{
                      name: 'titular',
                      disabled: statePantalla.loadingForm,
                    }}
                    rules={{
                      required: 'Este campo es obligatorio',
                    }}
                  />
                </SimpleContainer>
              </div>

              <div className="col-md-6 form-group">
                <SimpleContainer label="Vencimiento" name="expiracion">
                  <TextInputMask
                    disabled={statePantalla.loadingForm}
                    mask="99/9999"
                    placeholder="mm/aaaa"
                    name="expiracion"
                    unmask={false}
                    rules={EXPIRACION_RULES}
                  />
                </SimpleContainer>
              </div>

              {medioPago?.value === MEDIOS_PAGO.pago && (
                <div className="col-md-6 form-group">
                  <SimplePasswordInputField
                    label="CVV"
                    name="cvv"
                    type="number"
                    isInt
                    disabled={statePantalla.loadingForm}
                    rules={CVV_RULES(longitudCvv)}
                  />
                </div>
              )}
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default FormTarjeta;
